import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { FiX } from 'react-icons/fi';
import { useMeasure } from 'react-use';

import { renderNode } from '../../helpers';
import { useTitle } from '../../hooks';
import styles from './ModalSheetHeader.scss';

export function ModalSheetHeader({
    title,
    closePath,
    rightButton,
    light,
    closeIcon: CloseIcon = FiX,
    bottomContent,
    ...rest
}) {
    const [rBtn, { width }] = useMeasure();
    const padding = width > 50 ? width : 50;
    const isCloseFunction = typeof closePath === 'function';
    const closeProps = isCloseFunction ? { onClick: () => closePath() } : { to: closePath };
    const CloseTag = isCloseFunction ? 'div' : Link;

    useTitle(title);

    return (
        <>
            {title !== false && (
                <div
                    className={cn({
                        [styles.root]: true,
                        [styles.light]: light,
                        [styles.noBorder]: bottomContent || !title,
                    })}
                    {...rest}
                >
                    {closePath && (
                        <CloseTag className={styles.icon} {...closeProps}>
                            <CloseIcon size={22} color="#333" />
                        </CloseTag>
                    )}
                    <span className={styles.title} style={{ padding: `0 ${padding}px` }}>
                        {title}
                    </span>
                    {!!rightButton && (
                        <div ref={rBtn} className={styles.rightButton}>
                            {renderNode(rightButton)}
                        </div>
                    )}
                </div>
            )}
            {bottomContent && <div className={styles.bottomContent}>{bottomContent}</div>}
        </>
    );
}

ModalSheetHeader.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.element]),
    light: PropTypes.bool,
    closeIcon: PropTypes.elementType,
    closePath: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    rightButton: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.bool]),
    bottomContent: PropTypes.any,
};
